import { createSlice } from "@reduxjs/toolkit";

export const pendingService = createSlice({
  name: "pendingService",
  initialState: {
    isOpen: false,
    status: "",
    icon: false,
    activeId: null,
    data: null,
    orderId: null,
  },
  reducers: {
    openPendingService: (state, action) => {
      state.isOpen = action.payload;
    },
    closePendingService: (state, action) => {
      state.isOpen = action.payload;
    },
    setActiveId: (state, action) => {
      state.activeId = action.payload;
    },
    IsShowIcon: (state, action) => {
      state.icon = action.payload;
    },
    setPendingServiceData: (state, action) => {
      state.data = action.payload;
    },
    setPendingServiceOrderId: (state, action) => {
      state.orderId = action.payload;
    },
  },
});

export const {
  openPendingService,
  closePendingService,
  setActiveId,
  IsShowIcon,
  setPendingServiceData,
  setPendingServiceOrderId,
} = pendingService.actions;

export const selectPendingServiceIsOpen = (state) =>
  state.pendingService.isOpen;
export const selectActiveId = (state) => state.pendingService.activeId;
export const selectIsShowIcon = (state) => state.pendingService.icon;
export const selectPendingServiceData = (state) => state.pendingService.data;
export const selectPendingServiceOrderId = (state) =>
  state.pendingService.orderId;

export default pendingService.reducer;
